import { NavLink } from 'react-router-dom';

const MENU = [
    { to: '/admin/ai-clients', label: 'AI 내담자 결과' },
    { to: '/admin/feedback', label: '피드백' },
    { to: '/admin/inquiries', label: '문의사항' },
    { to: '/admin/contacts', label: '기업 문의' },
];

// 관리자 왼쪽 메뉴. 현재 화면의 메뉴를 강조한다.
export default function AdminSidebar() {
    return (
        <nav className="admin-sidebar" aria-label="관리자 메뉴">
            <ul>
                {MENU.map(item => (
                    <li key={item.to}>
                        <NavLink to={item.to} className={({ isActive }) => (isActive ? 'active' : undefined)}>{item.label}</NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
